import React, { useContext } from "react";
import Select from "../../Components/Select";
import TenantContext from "../../OnlineFormContext";
import AARCodes from "./AARCodes";

function System({ selected, onChange, equipmentType,equipmentTypeId, hasError }) {
  const contextValues = useContext(TenantContext);
  const aarCodes = new AARCodes(contextValues.tenantAuthToken, equipmentType, equipmentTypeId);

  return (
    <div className="ui fluid input bs-field">
      <Select
        asynchronous={true}
        paginate={true}
        value={selected}
        loadOptions={async (search, _, { page }) => ({
          ...(await aarCodes.systemOptions(search, page)),
          additional: {
            page: page + 1,
          },
        })}
        onChange={(e) => {
          onChange(e);
        }}
        additional={{
          page: 1,
        }}
        cacheUniq={[selected]}
        placeholder={"System"}
      />
    </div>
  );
}

export default System;
